import EventBus from "./event-bus";

const axios = require('axios');

import {errorHandler} from "./common";

export function getHistory(query) {
  return new Promise(function (resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/history?' + query, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
  })
}



// WEBPACK FOOTER //
// ./src/api/history.js